// extracted by mini-css-extract-plugin
export default {"search":"ClusterStoreDetailHeader_search__FQiBi","search__input":"ClusterStoreDetailHeader_search__input__nfTty","search__button":"ClusterStoreDetailHeader_search__button__sh527"};